export default {
  /**
   * Yêu cầu nộp dự toán
   */
  RequestSubmitEstimate: 1,
  /**
   * Thông báo ban hành
   */
  PublishDictionary: 2,

  /**
   * Thông báo hoàn thành
   */
  Complete: 3,

  /**
   * Thông báo gửi trả
   */
  Reject: 4,

  /**
   * Thông báo hủy hoàn thành
   */
  CancelComplete: 5,

  /**
   * Yêu cầu thu hồi
   */
  RevokeRequest: 6,

  /**
   * Chấp nhận yêu cầu thu hồi
   */
  AcceptRevoke: 7,
  /**
   * Nộp dự toán
   */
  SubmitEstimate: 8,

  SendSyncTemplates: 9,

  /**
   * thông báo trần chi từ cấp trên gửi xuống
   */
  NotiCeilingExpense: 10,

  /**
   * giao quyết định giao
   */
  DeliverAllocation: 11,
  /**
   * thu hồi quyết định giao
   */
  RevokeAllocation: 12,

  /**
   * Cảnh báo gia hạn
   */
  WarningExpired : 14,
};
